import { useMemo } from 'react';
import { HeatmapLayer as DeckHeatmapLayer } from '@deck.gl/aggregation-layers';

import DeckGlOverlay from './DeckGlOverlay';

const HeatmapLayer = ({ heatmapPoints, radius }) => {
  const layers = useMemo(
    () => [
      new DeckHeatmapLayer({
        id: 'heatmap-layer',
        data: heatmapPoints,
        radiusPixels: radius,
        getPosition: point => [point.longitude, point.latitude],
        getWeight: point => point.weight ?? 1
      })
    ],
    [heatmapPoints, radius]
  );

  return <DeckGlOverlay layers={layers} />;
};

export default HeatmapLayer;